// removed by extract-text-webpack-plugin
module.exports = {"ScreenXSMax":"(max-width: 767px)","cancelButton":"Gcb05a7"};